const pick = require('../utils/pick');
const { getConfiguration } = require('../config');
const { AVAILABILITY } = require('../../constants/initiatives');
const {
  AVAILABILITY_FAILURE,
  AVAILABILITY_TRANSFER_SIZE,
  AVAILABILITY_BROWSER_ERRORS,
} = require('../../constants/metrics');
const { METRICS } = require('../../constants/configurations');


const preparePayload = (settings, data) => {
  const metrics = getConfiguration(METRICS, AVAILABILITY);
  const collection = pick(data, metrics);

  if (!Object.keys(collection).length) {
    throw new Error('Metrics not found');
  }

  return {
    name: AVAILABILITY,
    data: {
      [AVAILABILITY_FAILURE]: collection[AVAILABILITY_FAILURE],
      [AVAILABILITY_TRANSFER_SIZE]: collection[AVAILABILITY_TRANSFER_SIZE],
      [AVAILABILITY_BROWSER_ERRORS]: collection[AVAILABILITY_BROWSER_ERRORS],
    },
  };
};

module.exports = preparePayload;
